/** @jsx jsx */
import { Plural } from '@lingui/macro';
import { jsx } from 'theme-ui';
import DefaultFacet from '../DefaultFacet/DefaultFacet';
import useProductFacetTranslation from './useProductFacetTranslation';

export default function ProductPriceRangeFacet({
  allValues,
  selectedValues,
  onToggle,
  totalCount,
  count,
  ...rest
}) {
  const translate = useProductFacetTranslation();
  return (
    <DefaultFacet
      multiSelect
      title={
        <Plural
          value={allValues?.length}
          one="# price range"
          other="# price ranges"
        />
      }
      allValues={allValues?.map((range) => ({
        ...range,
        label: translate.priceRange(range.value),
      }))}
      selectedValues={selectedValues}
      onToggle={onToggle}
      totalCount={totalCount}
      count={count}
      {...rest}
    />
  );
}
